// extracted by mini-css-extract-plugin
export default {"breadCrump":"CoaList_breadCrump__19-0V"};